import React from "react"
import PropTypes from "prop-types"
import { RichText } from "prismic-reactjs"

/**
 * Image caption component
 */
const Caption = ({ caption }) => {
  if (RichText.asText(caption) !== "") {
    return (
      <p>
        <span className="image-label">{RichText.asText(caption)}</span>
      </p>
    )
  }

  return null
}

Caption.propTypes = {
  caption: PropTypes.string.isRequired,
}

export default Caption
